export { BreakpointsApiKey } from './publicApiKey';
export { BreakpointsEntryPoint } from './breakpointsEntryPoint';
export {
  getDesktopBreakpointDefinition,
  getMobileBreakpointDefinition,
} from './utils';
export type { BreakpointsApi } from './breakpointsApi';
